module.exports = __webpack_public_path__ + "static/operadorasResp-8702788e491428871e9040e481dd2f89.png";